

export const ALLITEMS = [

        {
            id: 0,
            type: "e",
            from: 1992,
            end: 1996,
            company: "George Washington University Law School",
            title: "Juris Doctor with Honors",
            experience: [
                "Member, George Washington Journal of International Law & Economics, Phi Delta Phi Law Fraternity, International Law Society, and Student Intellectual Property Law Association",
                "Article on Software Copyright Law in Thailand",
                "Selected to join The Alternative Dispute Resolution Board based upon performance in 1996 Client Counseling Competition",
                "Pro Bono Honor Recipient - for significant contribution to public service"
                        ],
            image: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/gw.jpg",
            imagelink: "",
            rightimage: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/jdDiploma.png",
            rightlink: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/jdDiploma.png",
            rightimage2: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/jdgw.jpg",
            rightlink2: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/jdgw.jpg"
        },
        
        {
            id: 1,
            type: "e",
            from: 1990,
            end: 1991, 
            type: "e",
            company: "Webster University Netherlands Campus",
            title: "Masters of Arts in Computer Resource Management",
            experience: [
                "The 'Oustanding Graduate Student Award' for 1990-1991",
                "Grade Point Average of 3.82",
                "Internship to develop a workflow for the application procedure"
                        ],
            image: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/webster.jpg",
            imagelink: "",
            rightimage: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/maDiploma.png",
            rightlink: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/maDiploma.png",
            rightimage2: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/award.jpg",
            rightlink2: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/award.jpg"
            
            
        },
        {
            id: 2,
            type: "e",
            from: 1972,
            end: 1976,
            company: "University of Colorado",
            title: "Bachelor's Degree in Mathematics with Computer Science",
            experience: [
                "GPA 3.45 (3.8 in Computer Science)",
                "Dean's List 6 semesters",
                "4.0 Last Semester"
                        ],
            image: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/cu.jpg",
            imagelink: "",
            rightimage: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/baDiploma.jpg",
            rightlink: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/baDiploma.jpg"   
            
        },
        
        {
            id: 3,
            type: "l",
            from: 1995,
            end:1997,
            company: "Swidler & Berlin Attorneys at Law",
            title: "Associate Attorney",
            experience: [
                "Legal Research and Legal Memorandum",
                "Software intellectual property litigation",
                "Insurance litigation",
                "Utilities litigation",
                "Telecommunications regulatory activities",
                "Antitrust Litigation",
                "Legislative issue support",
                "Native American law"
                        ],
            image: "",
            imagelink: "",
            rightimage: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/swid1.jpg",
            rightlink: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/swid.pdf"
        },
        
        {
            id: 4,
            type: "l",
            from: 1994,
            end: 1994,
            company: "United States Supreme Court",
            title: "Legal Research Clerk",
            experience: [
                "Intensive legal and historical research in support of U.S. Supreme Court opinions",
                "Draft Supreme Court orders",
                "Support Supreme Court Justice speeches and publications",
                "Received numerous thank-you letters including one from Justice Souter",
                "Fixed and maintained the database of legal opinions"
                        ],
            image: "",
            imagelink: "",
            rightimage: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/supreme.jfif",
            rightlink: ""   
            
        },
        {
            id: 5,
            type: "l",
            from: 1995,
            end :1995,
            company: "Roberts and Associates",
            title: "Law Clerk",
            experience: [
                "Research and production of software patent prosecution",
                "Research and creation of draft on computer generated evidence (Published)"
                        ],
            image: "",
            imagelink: "",
            rightimage: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/evid.jpg",
            rightlink: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/evid.pdf"   
            
        },
        {
            id: 6,
            type: "l",
            from: 1994,
            end:1996,
            company: "Public Defender Service of Washington, D.C.",
            title: "Felony Investigator and Law Clerk",
            experience: [
                "Record witness statements",
                "Retrieve information from both government and private sources",
                "Serve subpoenas"
                        ],
            image: "",
            imagelink: "",
            rightimage: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/public.png",
            rightlink: ""   
            
        },
        {
            id: 7,
            type: "b",
            from: 1998,
            end: 2003, 
            company: "Webster University -- The Netherlands",
            title: "Head of Department of Business & Technology",
            experience: [
                "Served as an integral member of the Management Team; oversaw recruitment, hiring and scheduling of all departmental faculty members",
                "Scheduled faculty members in an efficient manner that best served the student population; created a five-year schedule based on faculty availability and performance",
                "Worked on several special projects e.g. lectures series, traveling MBA programs and cultural immersion initiatives; served as the idea person and the change manager during the course of these projects",
                "Introduced a number of new courses and formats that were adopted globally by the University",
                "Instructed over 70 courses in 20 different content areas",
                "During my tenure, the MBA program was ranked number three in The Netherlands",
                "Created the Cultural Immersion Program",
                "Created the MBA Asian Experience Program"
                        ],
            image: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/webster1.jpg",
            imagelink: "",
            rightimage: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/cult.png",
            rightlink: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/cult.pdf" 
        },
        {
            id: 8,
            type: "b",
            from: 1997,
            end: 1999,
            company: "Olivetti Systems - The Netherlands",
            title: "Director of Work Management",
            experience: [
                "Supervised and coached a group of 100 staff members, evenly split between internal and external employees",
                "Served as a Project Manager for large a KLM project and the Quality Manager for a  large ABN-AMRO project",
                "Worked with team transition to Wang Global; took over project responsibilities for a plan to scan and obtain all information on Wang’s 12M daily tickets",
                "Introduced quality organization in all projects and utilized standardized Project Management methodology"

                        ],
            image: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/klm.jfif",
            imagelink: "",
            rightimage: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/quality.jpg",
            rightlink: "",
            rightimage2: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/pm.png"
            
        },
        {
            id: 9,
            type: "b",
            from: 1989,
            end: 1993,
            company: "MAI Nederland- The Netherlands",
            title: "Project Manager/ Software Engineer",
            experience: [
                "Project Manager for complete modernization of software development methodologies for a large software development department",
                "Created a Windows based environment allowing applications to be multi-platform",
                "Consultant to the Management Team",
                "Developed a C-based 4th Generation application and workflow environment"
                        ],
            image: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/wm.jfif",
            imagelink: "",
            rightimage: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/orpheus.jpg",
            rightlink: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/orpheus.pdf"   
            
        },
        {
            id: 10,
            type: "b",
            from: 1987,
            end: 1989,
            company: "Datagrahics",
            title: "Director of Database Applications/ Software Engineer",
            experience: [
                "Document management projects for Great Britain Water Works, British Petroleum, French Ministry of Agriculture, and French Opera Bastille in Europe",
                "Project for BP was related in a success story article in the Financial Times",
                "Directed development of document management software package in US. Clients included Martin Marietta, PG&E, Babcock Wilcox, U.S. Navy, U.S. Army and NASA",
                "Pre and post sales support for these multi-million dollar projects",
                "Developed a C-based application for Document and Image Management. Created a Workflo API."
                        ],
            image: "",
            imagelink: "",
            rightimage: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/datagraphics.jpg",
            rightlink: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/datagraphics.jpg",
            rightimage2:  "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/datagraphic.png"
            
        },
        {
            id: 11,
            type: "b", 
            from: 1986,
            end: 1987,
            company: "Wang China",
            title: "Product Manager/Software Engineer",
            experience: [
                "Managed Wang CAD/CAM business in China",
                "Create the first newspaper publishing software in Chinese",
                "Newspaper Project was complete success and came in on time and budget to the day",
                "Developed Chinese Window and Input Methodology",
                "Developed Chinese Font Management Software",
                "Developed Graphic Package"
                
                        ],
            image: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/guang.jpg",
            imagelink: "",
            rightimage: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/newspaper.jpg",
            rightlink: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/newspaper.jpg" 
        },
        {
            id: 12,
            type: "b",
            from: 1982,
            end: 1986,
            company: "FileNet Corporation",
            title: "Application Architect/System Engineer",
            experience: [
                "Responsible for all user interface applications architecture",
                "First company with Document Management and Workflow capabilities",
                "Start up company",
                "Projects included Security Pacific Bank, Australian Patent Office, Utah State Records, USAA Insurance, and Olivetti",
                "Created API for all user interfaces. Custom wrote applications for first customers. Unix and C windowing environment"

                        ],
            image: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/filenet1.png",
            imagelink: "",
            rightimage: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/filenet.png",
            rightlink: "",
            rightimage2: ""
            
        },
        {
            id: 13,
            type: "b",
            from: 1977,
            end:1983,
            company: "MAI/Basic Four",
            title: "European Software Manager/Programmer",
            experience: [
                "Management team member for European Headquarters",
                "Responsible for cross border software opportunities",
                "Project Manager for special projects",
                "Supported ten European subsidiaries and dealers",
                "Oversaw successful development of 4th generation project that became a major worldwide product (ORIGIN)"
                        ],
            image: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/mai.jpg",
            imagelink: "",
            rightimage: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/quick.jpg",
            rightlink: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/quick.pdf"   
            
        },
        {
            id: 14,
            type: "b",
            from: 1976,
            end: 1977,
            company: "General Motors",
            title: "Project Leader SUB System",
            experience: [
                "Responsible for Supplemental Unemployment Benefit System for 1.2 million employees",
                "Specialist on Database manipulation"
                        ],
            image: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/gm.png",
            imagelink: "",
            rightimage: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/sub.jfif",
            rightlink: "",
            rightimage2:  ""
            
        },
       
        {
            id: 15,
            type: "s",
            from: 2014,
            end: 2018,
            company: "TEACH-NOW Graduate School of Education",
            title: "Faculty",
            experience: [
                "Teaching online education modules in a program to allow adult learners to gain teaching certification",
                "Teach in a state-of-the-art, online, collaborative learning space adhering to best practices in on-line teaching and delivery of course content",
                "Teach the material from the approved TEACH-NOW curriculum in accordance with assigned module",
                "Taught over 50 graduate courses including 'The Learner and Learning in a Digital Age' and    'Student Assessments'",
                "Actively monitor and document individual candidate progress and provide support and direction as needed",
                "Assess candidate performance and give timely specific feedback that will assist candidates in understanding module content and improving future performance",
                "Maintain online asynchronous or synchronous communication with candidates in threaded class discussion and/or email to assist them in achieving course objectives"
                        ],
            image: "",
            imagelink: "",
            rightimage: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/teachnowlist.png",
            rightlink: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/AllMyClasses.pdf",
            rightimage2: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/teachnow.png"
        },
        {
            id: 16,
            type: "s",
            from: 2012,
            end: 2014,
            company: "American International School of Jeddah",
            title: "Director of Information Technology and Integration",
            experience: [
                "Supervised a team of professionals including IT and AV staff; worked cohesively to expand and manage the IT Infrastructure ",
                "Supported 21st century curriculum initiatives, including professional training, introduction of new technological tools and development of websites ",
                "Part of a planning team for a move to a 1-1 iPad's in Middle School",
                "Installed and maintained Moodle environment",
                "Presented Professional Development on 21st Century Teaching Skills",
                "Helped many teachers move from a traditional classroom to a flipped web-supported learning environment",
                "Supported a faculty laptop initiative as well as supplying all classrooms with a Document Camera and a Projector",
                "Primary administrator for Google Apps and for the Renweb School Administration Software"

                        ],
            image: "",
            imagelink: "",
            rightimage: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/websites2.png",
            rightlink: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/websites.pdf", 
            rightimage2: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/aisj.jpg",
            rightlink2: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/websites.pdf"  
            
        },
        
        {
            id: 17,
            type: "s",
            from: 2011,
            end: 2012,
            company: "Uruguayan American School",
            title: "IT Coordinator and IT and Digital Photography Instructor",
            experience: [
                "Teaching Digital Photography and MS Technology",
                "Successfully introduced the 'Classroom of the Future' initiative, which served to change and enhance the technology infrastructure in classroom settings;  implemented Google Drive and Gmail usage",
                "PowerSchool support and development",
                "Established a 21st century curriculum rooted in technology and digital media; devised teacher and student websites for content areas and homework",
                "Introduced Google Apps Technology"
                        ],
            image: "",
            imagelink: "",
            rightimage: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/uru1.jpg",
            rightlink: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/uru1.jpg",
            rightimage2: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/uru2.jpg",
            rightlink2: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/uru2.jpg"
            
            
        },
        {
            id: 18,
            type: "s",
            from: 2009,
            end: 2011,
            company: "International School of Florence, Florence, Italy",
            title: "ICT Coordinator and ICT Instructor",
            experience: [
                "Teaching IB Information Technology in the Global Society and 6th, 8th, 9th, 10th ICT courses",
                "Introduced a new technology curriculum that was incorporated across all levels of the institution; taught students to create websites, use animation software and utilized Photoshop to support their course assignments",
                "MAP testing Technical Coordinator",
                "Facilitated technology-based training and development for all teachers ",
                "Introduced Google Apps Technology"
                        ],
            image: "",
            imagelink: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/isfsmall.mp4",
            rightimage: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/isfschool.jpg",
            rightlink: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/isfsmall.mp4",
            rightimage2: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/isfwide.jpg"
                
            
        },
        {
            id: 19,
            type: "s",
            from: 2008,
            end: 2009,
            company: "Songdo International School, Songdo International City, Korea",
            title: "Director of Educational Technology",
            experience: [
                "Planned an innovative 21st century “School of the Future” for New Songdo; including development of technology infrastructure plan",
                "Create complete technical architecture to support a 'School of the Future' learning environment",
                "Worked to develop and integrate Smart Card technology within the institution; offered students a Smart Card that allowed them access to lockers, classrooms, library checkouts, attendance and computer usage",
                "Introduced Google Apps Technology",
                "Designed and implemented a complete school website"
                        ],
            image: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/songdowide.jpg",
            imagelink: "",
            rightimage: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/songdo.png",
            rightlink: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/songdo.png",
            rightimage2: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/ChuckPres.jpg"
            
        },
        {
            id: 20,
            type: "s",
            from: 2007,
            end: 2008,
            company: "Keera-Pat International School, Bangkok, Thailand",
            title: "Social Studies Teacher, Middle and High School",
            experience: [
                "Provide scaffolding for experiences that develop independent learners",
                "Assess student progress through formal and informal assessments",
                "Created a classroom environment that promotes risk-taking, inquiry, collaboration, and discussion ",
                "Introduced Google Apps Technology"
                        ],
            image: "",
            imagelink: "",
            rightimage: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/isb.jpg",
            rightlink: "",
            rightimage2: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/keera.jpg"   
            
        },
        {
            id: 21,
            type: "s",
            from: 2006,
            end: 2007,
            company: "International School Bangkok, Thailand",
            title: "Substitute Teacher, K-12",
            experience: [
                "Gained experience from teaching in many different subject areas and grade levels across the school",
                        ],
            image: "",
            imagelink: "",
            rightimage: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/isb1.jpg",
            rightlink: ""   
            
        },
        {
            id: 22,
            type: "s",
            from: 1998,
            end: 2004,
            company: "American School of The Hague, The Netherlands",
            title: "Substitute Teacher, K-12",
            experience: [
                "Taught High School IB and AP Computer Programming",
                "Prepared students for IB and AP exams where they scored very well",
                "Taught High School C++ Computer Programming course",
                "Taught Grade 8 Math course"
            ],
            image: "",
            imagelink: "",
            rightimage: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/ash.png",
            rightlink: ""   
            
        },
        {
            id: 23,
            type: "s",
            from: 1997,
            end:2008,
            company: "Webster University, The Netherlands, and Thailand",
            title: "Professor and Head of Department of Business & Technology (The Netherlands) / MBA Coordinator (Thailand)",
            experience: [
                "Served as an integral member of the Management Team; oversaw recruitment, hiring and scheduling of all departmental faculty members",
                "Scheduled faculty members in an efficient manner that best served the student population; created a five-year schedule based on faculty availability and performance",
                "Worked on several special projects e.g. lectures series, traveling MBA programs and cultural immersion initiatives; served as the idea person and the change manager during the course of these projects",
                "Introduced a number of new courses and formats that were adopted globally by the University",
                "Instructed over 70 courses in 20 different content areas",
                "During my tenure, the MBA program was ranked number three in The Netherlands",
                "Created the Cultural Immersion Program",
                "Created the MBA Asian Experience Program"
                        ],
            image: "",
            imagelink: "",
            rightimage: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/cult.png",
            rightlink: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/cult.png",
            rightimage2: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/websterpano.jpg"   
            
        },
        {
            id: 24,
            type: "s",
            from: 1991,
            end: 1992,
            company: "Regis University, Colorado",
            title: "Professor",
            experience: [
                "Taught undergraduate courses in computer programming and business computers",
                        ],
            image: "",
            imagelink: "",
            rightimage: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/regis.jpg",
            rightlink: ""   
            
        },
        {
            id: 25,
            type: "s",
            from: 1991,
            end: 2016,
            company: "Professional Development",
            title: "Presenter",
            experience: [
                "Measurement of Academic Progress (MAP) Technical Coordinator",
                "Mediterranean Association of International Schools (MAIS) Conference, Florence, Italy, October 2009",
                "Rubicon Atlas Training, September 2007",
                "Emotional IQ and Personality Traits, September 2007",
                "EARCOS Workshop, Language Learning in the Classroom: Strategies for K-12 Classroom, Language and ESL Teachers, September 2007",
                "Presenter: 'Classroom of the Future', Educational Technology Conference, Buenos Aires, Argentina, May 13, 2012",
                "Presenter: East Asia Regional Council Overseas Schools (EARCOS) Administrators Conference, Borneo, Indonesia 'It is 2010 - What Now?', November 4, 2008"

            ],
            image: "",
            imagelink: "",
            rightimage: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/prof.jpg",
            rightlink: "",
            rightimage2: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/ChuckKnowledge.jpg"  
            
        },
        {
            id: 26,
            type: "t",
            from: 1998,
            end: 2018,
            company: "Education Experience",
            title: "Professor/Teacher/IT Manager",
            experience: [
                "Head of Dempartment of Business and Technology, Webster University (The Netherlands)",
                "MBA Coordinator Webster University (Thailand)",
                "K-12 teacher in Computers/Math/Social Studies",
                "Taught over 120 courses in over 20 subjects"
            ],
            
            image: "",
            imagelink: "",
            rightimage: "",
            rightlink: "",
            rightimage2: ""
            
        },
        {
            id: 27,
            type: "t",
            from: 1992,
            end: 1997,
            company: "Legal Experience",
            title: "Attorney/Legal Researcher/Felony Investigator/Patent Writer",
            experience: [
                "Attorney for large DC firm",
                "Legal researcher for United States Supreme Court",
                "Major Crimes Investigator for DC Public Defender",
                "Associate Patent writer"
            ],
            
            image: "",
            imagelink: "",
            rightimage: "",
            rightlink: "",
            rightimage2: ""
        
        },
        
        {
            id: 28,
            type: "t",
            from: 1997,
            end: 1998,
            company: "Olivetti/OLSY/Wang Global/Getronics",
            title: "Director, Work Management/Project Manager",
            experience: [
                "Supervised and coached a group of 100 staff members, evenly split between internal and external employees",
                "Served as a Project Manager for a large KLM project and the Quality Manager for a large ABN-AMRO project",
                "Worked with team transition to Wang Global; took over project responsibilities for a plan to scan and obtain all information on Wang’s 12M daily tickets",
                "Introduced quality organization in all projects and utilized standardized Project Management methodology"
            ],
            image: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/klm.jfif",
            imagelink: "",
            rightimage: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/quality.jpg",
            rightlink: "",
            rightimage2: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/pm.png"
            
        },
        {
            id: 29,
            type: "t",
            from: 1982,
            end: 1992,
            company: "Independent Consultant (The Netherlands, UK, Italy, US)",
            title: "Director/Consultant",
            experience: [
                "Architected and designed project for complete modernization of software development methodologies for a large software development department in The Netherlands",
                "Document management projects for Great Britain Water Works, British Petroleum, French Ministry of Agriculture, and French Opera Bastille.",
                "Quality Assurance Manager for bank teller application project (ABN/Amro)"
            ],
            image: "",
            imagelink: "",
            rightimage: "",
            rightlink: "",
            rightimage2: ""  
            
        },
        
        {
            id: 30,
            type: "t",
            from: 1987,
            end: 1989,
            company: "Datagraphics Systems Inc.",
            title: "Director/Consultant",
            experience: [
                "Directed development of document management software package",
                "Projects included Martin Marietta, PG&E, Babcock Wilcox, U.S. Navy, U.S. Army and NASA",
                "Wrote applications integrating the company CAD/CAM projects with Engineering Change Management"
            ],
            image: "",
            imagelink: "",
            rightimage: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/datagraphics.jpg",
            rightlink: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/datagraphics.jpg",
            rightimage2:  "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/datagraphic.png"  
            
        },
        {
            id: 31,
            type: "t",
            from: 1986,
            end: 1987,
            company: "Wang China",
            title: "Product Manager Cad/Cad",
            experience: [
                "Developed Chinese newspaper publishing package for the second largest newspaper in China",
                "Created Chinese Windows, Input Methods, and Fonts",
                "Project Manager of new Wang CAD/CAM terminal"
            ],
            image: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/guang.jpg",
            imagelink: "",
            rightimage: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/newspaper.jpg",
            rightlink: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/newspaper.jpg"   
            
        },
        {
            id: 32,
            type: "t",
            from: 1981,
            end: 1982,
            company: "Database Design Incorporated",
            title: "Trainer/Course Develeper",
            experience: [
                "Taught Data Modeling and Database Design using James Martin methods",
                "Created courses in Database Design, and Data Modeling",
                "Clients included U.S. Coast Guard, Federal Reserve, and Hobart",
                "Hosted International Data Modeling Conference."
            ],
            image: "",
            imagelink: "",
            rightimage: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/database.jfif",
            rightlink: "",
            rightimage2: ""  
        },
        {
            id: 33,
            type: "t",
            from: 1982,
            end: 1986,
            company: "FileNet Corporation",
            title: "Software Engineer/Application Architect",
            experience: [
                "First Workflow and Document Management Company",
                "Start up development of document imaging product for whole enterprise or departmental solutions",
                "Projects included Security Pacific Bank, Australian Patent Office, Utah State Records, USAA Insurance, and Olivetti.",
                "Very successful and bought by IBM"
            ],
            image: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/filenet1.png",
            imagelink: "",
            rightimage: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/filenet.png",
            rightlink: "",
            rightimage2: ""
            
        },
        {
            id: 34,
            type: "t",
            from: 1977,
            end: 1983,
            company: "MAI Basic Four Corporation/MAI International",
            title: "Software Support, European Software Specialist, European Software Director",
            experience: [
                "Supervised software projects for all of Europe ",
                "Projects included a GM telecommunications interface from Italian dealers to GM European Headquarters in Germany",
                "Managed and coordinated cross border software development and support for ten European subsidiaries and dealers",
                "Taught and developed numerous computer courses in ten different countries"
            ],
            image: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/mai.jpg",
            imagelink: "",
            rightimage: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/quick.jpg",
            rightlink: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/quick.pdf"    
            
        },
        {
            id: 35,
            type: "t",
            from: 1982,
            end: 1986,
            company: "General Motors Corporation",
            title: "Programmer Analyst",
            experience: [
                "Programmer Analyst, Corporate Headquarters in Detroit, Michigan",
                "Maintained Supplemental Unemployment Benefits System.",
                "Specialist on Data Retrieval Software"
            ],
            image: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/gm.png",
            imagelink: "",
            rightimage: "http://www.charlessuits.org/sites/MrSuits.net/charlessuits/img/sub.jfif",
            rightlink: "",
            rightimage2:  ""
            
        }
    

    ];